// Mock data for ApexForge Markets clone (frontend-only demo)

export const CATEGORIES = [
  'All',
  'Artificial Intelligence',
  'Aerospace & Defense',
  'Fintech & Payments',
  'Enterprise Software',
  'Consumer Tech',
  'Biotech & Neural',
];

export const companies = [
  {
    id: 'bytedance',
    name: 'ByteDance Ltd. (TikTok Parent)',
    ticker: 'BYTEDANCE',
    icon: 'Smartphone',
    category: 'Consumer Tech',
    description:
      'Global digital media and algorithm giant, developer of TikTok, Douyin, CapCut, and advanced machine learning recommendation systems serving billions.',
    lastPrice: 182.2,
    change: -1.78,
    valuation: 225.0,
    bid: 179.5,
    ask: 184.0,
    minLot: 50000,
    volume: 8.2,
  },
  {
    id: 'spacex',
    name: 'Space Exploration Technologies Corp.',
    ticker: 'SPACEX',
    icon: 'Rocket',
    category: 'Aerospace & Defense',
    description:
      'Pioneering orbital launch provider and global satellite internet mega-constellation (Starlink), preparing humanity for multi-planetary life.',
    lastPrice: 112.44,
    change: 2.22,
    valuation: 210.0,
    bid: 111.0,
    ask: 113.8,
    minLot: 25000,
    volume: 6.1,
  },
  {
    id: 'openai',
    name: 'OpenAI Technologies Inc.',
    ticker: 'OPENAI',
    icon: 'Sparkles',
    category: 'Artificial Intelligence',
    description:
      'Frontier artificial intelligence research and commercial deployment company, creators of ChatGPT, GPT-4o, and the o-series reasoning models.',
    lastPrice: 285.99,
    change: 5.14,
    valuation: 157.0,
    bid: 283.0,
    ask: 288.5,
    minLot: 50000,
    volume: 11.4,
  },
  {
    id: 'stripe',
    name: 'Stripe Inc.',
    ticker: 'STRIPE',
    icon: 'CreditCard',
    category: 'Fintech & Payments',
    description:
      'Financial infrastructure platform powering internet commerce, subscription billing, banking-as-a-service, and global money movement for millions.',
    lastPrice: 40.49,
    change: 3.17,
    valuation: 80.0,
    bid: 40.0,
    ask: 41.0,
    minLot: 20000,
    volume: 4.7,
  },
  {
    id: 'databricks',
    name: 'Databricks Inc.',
    ticker: 'DATABRICKS',
    icon: 'BarChart3',
    category: 'Enterprise Software',
    description:
      'Data intelligence and lakehouse platform unifying data engineering, governance, business analytics, and generative AI for the enterprise.',
    lastPrice: 78.33,
    change: 1.73,
    valuation: 48.0,
    bid: 77.5,
    ask: 79.2,
    minLot: 20000,
    volume: 3.9,
  },
  {
    id: 'anthropic',
    name: 'Anthropic PBC',
    ticker: 'ANTHROPIC',
    icon: 'Hexagon',
    category: 'Artificial Intelligence',
    description:
      'AI safety and alignment research company, creators of the frontier Claude 3.5 Sonnet and Claude 3.5 Opus large language models.',
    lastPrice: 48.66,
    change: 7.89,
    valuation: 45.0,
    bid: 47.8,
    ask: 49.5,
    minLot: 25000,
    volume: 5.3,
  },
  {
    id: 'epic',
    name: 'Epic Games Inc.',
    ticker: 'EPIC',
    icon: 'Gamepad2',
    category: 'Consumer Tech',
    description:
      'Creators of Unreal Engine 5, Fortnite metaverse ecosystem, and Epic Games Store digital distribution platform for interactive entertainment.',
    lastPrice: 62.01,
    change: -2.34,
    valuation: 32.0,
    bid: 61.2,
    ask: 63.0,
    minLot: 25000,
    volume: 2.8,
  },
  {
    id: 'canva',
    name: 'Canva Pty Ltd.',
    ticker: 'CANVA',
    icon: 'Palette',
    category: 'Enterprise Software',
    description:
      'Visual communication and design AI platform empowering over 190 million monthly active users and teams to create, collaborate, and publish.',
    lastPrice: 84.15,
    change: 2.8,
    valuation: 32.0,
    bid: 83.2,
    ask: 85.1,
    minLot: 15000,
    volume: 3.1,
  },
  {
    id: 'anduril',
    name: 'Anduril Industries Inc.',
    ticker: 'ANDURIL',
    icon: 'Shield',
    category: 'Aerospace & Defense',
    description:
      'Autonomous defense systems company building Lattice OS, autonomous interceptors (Roadrunner), and Ghost surveillance drones for allied forces.',
    lastPrice: 38.41,
    change: 4.38,
    valuation: 14.0,
    bid: 37.9,
    ask: 39.2,
    minLot: 20000,
    volume: 2.2,
  },
  {
    id: 'neuralink',
    name: 'Neuralink Corp.',
    ticker: 'NEURALINK',
    icon: 'BrainCircuit',
    category: 'Biotech & Neural',
    description:
      'Brain-computer interface (BCI) technology company developing high-bandwidth implantable devices to restore autonomy and expand human cognition.',
    lastPrice: 41.91,
    change: 6.1,
    valuation: 8.5,
    bid: 41.0,
    ask: 43.5,
    minLot: 25000,
    volume: 1.9,
  },
];

export const pipeline = [
  {
    id: 'xai',
    name: 'xAI Corp.',
    ticker: 'XAI',
    icon: 'Sparkles',
    category: 'Artificial Intelligence',
    description:
      'Frontier AI lab building Grok and large-scale reasoning models, integrated across the X platform and Colossus supercompute cluster.',
    targetValuation: 50.0,
    indicativePrice: 96.0,
    openDate: 'Q3 2025',
    demand: 88,
  },
  {
    id: 'revolut',
    name: 'Revolut Ltd.',
    ticker: 'REVOLUT',
    icon: 'CreditCard',
    category: 'Fintech & Payments',
    description:
      'Global neobank and super-app offering multi-currency accounts, crypto, trading, and cross-border payments to 45M+ retail customers.',
    targetValuation: 45.0,
    indicativePrice: 71.5,
    openDate: 'Q4 2025',
    demand: 74,
  },
  {
    id: 'discord',
    name: 'Discord Inc.',
    ticker: 'DISCORD',
    icon: 'MessageCircle',
    category: 'Consumer Tech',
    description:
      'Real-time voice, video and text communication platform anchoring gaming, creator, and community ecosystems worldwide.',
    targetValuation: 15.0,
    indicativePrice: 44.2,
    openDate: 'Q4 2025',
    demand: 61,
  },
  {
    id: 'waymo',
    name: 'Waymo LLC',
    ticker: 'WAYMO',
    icon: 'Car',
    category: 'Aerospace & Defense',
    description:
      'Autonomous driving technology company operating fully driverless ride-hail fleets across major US metropolitan markets.',
    targetValuation: 45.0,
    indicativePrice: 88.9,
    openDate: 'Q1 2026',
    demand: 69,
  },
  {
    id: 'fanatics',
    name: 'Fanatics Holdings Inc.',
    ticker: 'FANATICS',
    icon: 'Trophy',
    category: 'Consumer Tech',
    description:
      'Global digital sports platform spanning licensed merchandise, collectibles, trading cards, and regulated sports betting.',
    targetValuation: 25.0,
    indicativePrice: 52.4,
    openDate: 'Q1 2026',
    demand: 55,
  },
  {
    id: 'chime',
    name: 'Chime Financial Inc.',
    ticker: 'CHIME',
    icon: 'Landmark',
    category: 'Fintech & Payments',
    description:
      'Consumer fintech offering fee-free mobile banking, early direct deposit, and credit-building products to mainstream America.',
    targetValuation: 25.0,
    indicativePrice: 39.7,
    openDate: 'Q2 2026',
    demand: 48,
  },
  {
    id: 'rippling',
    name: 'Rippling People Center Inc.',
    ticker: 'RIPPLING',
    icon: 'Users',
    category: 'Enterprise Software',
    description:
      'Unified workforce platform automating HR, IT, and finance operations from a single employee system of record.',
    targetValuation: 16.0,
    indicativePrice: 34.5,
    openDate: 'Q2 2026',
    demand: 42,
  },
];

// Mock admin user roster (frontend-only demo data)
const _hx = (n) => Math.abs(n).toString(16).padStart(8, '0').slice(0, 8);
export const adminUsers = Array.from({ length: 34 }).map((_, i) => ({
  id: `${_hx(0x7bfe92a8 + i * 104729)}-${(0x2ec6 + i * 37).toString(16).padStart(4, '0')}-4f8a-b${i.toString().padStart(3, '0')}`,
  name: 'Unnamed Investor',
  wallet: 1500000,
  kyc: i === 0 ? 'verified' : 'unverified',
}));

export const ADMIN_CREDENTIALS = { user: 'admin', password: 'ApexForge@2025' };

// Generate a synthetic order book from a company's price
export function buildOrderBook(company) {
  const bids = [];
  const asks = [];
  const base = company.lastPrice;
  for (let i = 0; i < 8; i++) {
    const bidPrice = +(company.bid - i * (base * 0.004)).toFixed(2);
    const askPrice = +(company.ask + i * (base * 0.004)).toFixed(2);
    const bidSize = Math.round(500 + Math.random() * 4000);
    const askSize = Math.round(500 + Math.random() * 4000);
    bids.push({ price: bidPrice, size: bidSize, total: bidSize });
    asks.push({ price: askPrice, size: askSize, total: askSize });
  }
  // cumulative totals
  let bcum = 0;
  bids.forEach((b) => {
    bcum += b.size;
    b.total = bcum;
  });
  let acum = 0;
  asks.forEach((a) => {
    acum += a.size;
    a.total = acum;
  });
  return { bids, asks };
}
